import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useScanDocumentsSettings() {
  const {
    tours: {
      AccountingSettings: { ScanDocuments },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: ScanDocuments.Title,
      steps: [
        {
          content: ScanDocuments.Step1.Text,
          placement: 'auto',
          target: '#scanDocuments',
          title: ScanDocuments.Step1.Title,
          disableBeacon: true,
          link: ScanDocuments.Step1.DetailsLink,
        },
        {
          content: ScanDocuments.Step2.Text,
          placement: 'auto',
          target: '#scanSettings',
          title: ScanDocuments.Step2.Title,
          disableBeacon: true,
          link: ScanDocuments.Step2.DetailsLink,
        },
      ],
    }),
    [ScanDocuments],
  );

  return [pageTour];
}
